/**
 * @file_purpose  page for showing video portfolio
 * @author Sucheta Singha
 * @Date_Created 19-09-2024
 * @Date_Modified 19-09-2024
 */
import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import RouteURL from "src/apis/ApiURL";
import Constants from 'src/Utility/Constants';
import GeneralService from 'src/apis/GeneralService';
import VideoPortBanner from "../../../assets/icons/video_banner.png"
import VideoLogo from "../../../assets/icons/vid_logo.png"
// import Video1 from "../../../assets/icons/vid_logo1.png"
// import Video2 from "../../../assets/icons/vid_logo2.png"
// import Video3 from "../../../assets/icons/vid_logo3.png"

export default function VideoPortfolio() {

    const [loadingData, setLoadingData] = useState(true);
    const [loader, setLoader] = useState(1);
    const history = useHistory();
    const location = useLocation();
    // const video_list = [
    //     {
    //         id: 1,
    //         title: "Red Apple 2D Art Portfolio",
    //         thumbnail: Video1,
    //         like_count: 175,
    //         dislike_count: 0,
    //         is_liked: 0,
    //         is_disliked: 0
    //     },
    //     {
    //         id: 2,
    //         title: "3D Art Portfolio",
    //         thumbnail: Video2,
    //         like_count: 176,
    //         dislike_count: 1,
    //         is_liked: 0,
    //         is_disliked: 1
    //     },
    //     {
    //         id: 3,
    //         title: "Casino & Slots",
    //         thumbnail: Video3,
    //         like_count: 177,
    //         dislike_count: 2,
    //         is_liked: 1,
    //         is_disliked: 0
    //     },
    // ];
    const [videoList, setVideoList] = useState([]);

    useEffect(() => {
        if (location.state) {
            if (location.state.otp_verified_status == "1") {
                if (localStorage.getItem('video_portfolio_verify_otp') == "1") {
                    history.push("/video-portfolio-details")
                }
            }

        } else {
            if (localStorage.getItem('video_portfolio_verify_otp') == "1") {
                history.push("/video-portfolio-details")
            }
        }
    }, []);

    useEffect(() => {
        /**
        * @author Sucheta Singha
        * @Date_Created 24/09/2024
        * @Date_Modified 24/09/2024
        * @function async
        * @functionName loadVideoList
        * @functionPurpose this function gets video list by filter wise.
        *
        * @functionParam {payload object:contact_id}
        * 
        * @functionSuccess Success status and message.
        *
        * @functionError {Boolean} error is there.
        * @functionError {String} message  Description message.
        */
        async function loadVideoList() {
            setLoader(1)
            GeneralService.apiPostCallRequestWithoutToken(RouteURL.videoPortfolioList, {})
                .then((res) => {
                    if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                        setVideoList(res.data)
                        setLoader(0)
                        setLoadingData(false)
                    }
                    else {
                        setLoader(0)
                    }
                }).catch(error => {
                    console.log(error);

                })
        }

        if (loadingData) {
            // if the result is not ready so you make the axios call
            loadVideoList()
        }


    }, [loadingData]);
    // const sendHeight = () => {

    //     window.parent.postMessage(window.screen.availHeight, '*');

    // }

    // // Send height initially and on content changes
    // window.addEventListener('load', sendHeight);
    // window.addEventListener('resize', sendHeight);

    // const observer = new MutationObserver(sendHeight);
    // observer.observe(document.body, { childList: true, subtree: true });


    const sendHeight = () => {
        // Send the height of the iframe content to the parent page
        window.parent.postMessage(document.body.scrollHeight, '*');
    };

    // Debounce function to limit the number of times sendHeight is called
    const debounce = (func, delay) => {
        let timer;
        return function () {
            clearTimeout(timer);
            timer = setTimeout(func, delay);
        };
    };

    // Create debounced version of sendHeight
    const debouncedSendHeight = debounce(sendHeight, 100);

    // Send height initially and on content changes
    window.addEventListener('load', debouncedSendHeight);
    window.addEventListener('resize', debouncedSendHeight);

    // Observe changes in the DOM with a slight delay to ensure rendering is complete
    const observer = new MutationObserver(debouncedSendHeight);
    observer.observe(document.body, { childList: true, subtree: true });


    const WatchNowClick = (e) => {
        e.preventDefault();
        history.push({
            pathname: `/video-portfolio-contact`,
        });
    }


    return (

        <body >

            <div className='video_portfolio_sec'>
                <div className="video_portfolio_inn" style={{ backgroundImage: 'url(' + VideoPortBanner + ')' }}>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-sm-12 col-xxl-4 col-xl-4 col-lg-4 col-md-12'>
                                <div className='video_portfolio_inn_lt'>
                                    <div className='video_portfolio_inn_lt_logo'>
                                        <img src={VideoLogo} alt='' />
                                        <p>ISO/IEC 27001:2013</p>
                                    </div>

                                    <div className='video_portfolio_inn_btm'>
                                        <h3>Welcome</h3>
                                        <p>Greetings, fellow gamers! We are thrilled to welcome you to our game development company, where we turn your gaming <br />dreams into reality.</p>
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-12 col-xxl-8 col-xl-8 col-lg-8 col-md-12'>
                                <div className='video_portfolio_inn_rt'>
                                    <div className='row'>

                                        {videoList.map((data, index) => (
                                            <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12'>
                                                <div className='video_portfolio_box1' key={index}>
                                                    <img src={data.thumbnail} alt='' />
                                                    <a className='watch_now' href="" onClick={WatchNowClick}>Watch Now <i class="fa-solid fa-play"></i></a>
                                                </div>
                                            </div>


                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </body>


    )
}


